import { render, staticRenderFns } from "./swipper.vue?vue&type=template&id=56eba65e&scoped=true"
import script from "./swipper.vue?vue&type=script&lang=js"
export * from "./swipper.vue?vue&type=script&lang=js"
import style0 from "./swipper.vue?vue&type=style&index=0&id=56eba65e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56eba65e",
  null
  
)

export default component.exports